import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @repo/internal/react/no-class-components */
import { PureComponent } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
export var WithProviders = /*#__PURE__*/function (_PureComponent) {
  _inherits(WithProviders, _PureComponent);
  var _super = _createSuper(WithProviders);
  function WithProviders(props) {
    var _this;
    _classCallCheck(this, WithProviders);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "mounted", false);
    _defineProperty(_assertThisInitialized(_this), "handleProviderIfMounted", function (name, provider) {
      if (!_this.mounted) {
        return;
      }
      _this.handleProvider(name, provider);
    });
    _defineProperty(_assertThisInitialized(_this), "handleProvider", function (name, provider) {
      _this.setState(function (_ref) {
        var providers = _ref.providers;
        return {
          providers: _objectSpread(_objectSpread({}, providers), {}, _defineProperty({}, name, provider))
        };
      });
    });
    _this.mounted = false;
    var _providers = {};
    _this.props.providers.forEach(function (name) {
      if (fg('platform_editor_react18_phase2_v2')) {
        var providerPromise = props.providerFactory.subscribe(name, _this.handleProviderIfMounted);
        _providers[name] = providerPromise;
      } else {
        _providers[name] = undefined;
      }
    });
    _this.state = {
      providers: _providers
    };
    return _this;
  }
  _createClass(WithProviders, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;
      if (!fg('platform_editor_react18_phase2_v2')) {
        var _this$props = this.props,
          providers = _this$props.providers,
          providerFactory = _this$props.providerFactory;
        providers.forEach(function (name) {
          providerFactory.subscribe(name, _this2.handleProvider);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      var _this$props2 = this.props,
        providers = _this$props2.providers,
        providerFactory = _this$props2.providerFactory;
      providers.forEach(function (name) {
        providerFactory.unsubscribe(name, _this3.handleProvider);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state,
        props = this.props;
      var renderNode = props.renderNode;
      return renderNode(state.providers);
    }
  }]);
  return WithProviders;
}(PureComponent);
_defineProperty(WithProviders, "displayName", 'WithProviders');